import cx from 'classnames';
import type {KeyboardEvent} from 'react';
import React, {useRef} from 'react';

interface MenuStaticProps extends PropsWithChildrenRequired, PropsWithClassNameOptional {}

const MenuStatic = ({children, className = ''}: MenuStaticProps) => {
  const menuRef = useRef<HTMLDivElement>(null);

  const handleKeyDown = (e: KeyboardEvent<HTMLDivElement>) => {
    if (!menuRef.current) return;

    const menuItems = Array.from(
      menuRef.current.querySelectorAll('[role="menuitem"]:not([tabindex^="-"])')
    ) as HTMLElement[];

    const currentIndex = menuItems.findIndex((item) => item === document.activeElement);

    switch (e.key) {
      case 'ArrowDown': {
        e.preventDefault();
        const nextIndex = (currentIndex + 1) % menuItems.length;
        menuItems[nextIndex]?.focus();
        break;
      }
      case 'ArrowUp': {
        e.preventDefault();
        const prevIndex = currentIndex <= 0 ? menuItems.length - 1 : currentIndex - 1;
        menuItems[prevIndex]?.focus();
        break;
      }
      default:
        break;
    }
  };

  return (
    <div
      role='menu'
      className={cx(
        className,
        'o-menu-content',
        'rounded-x1 border border-solid border-border-primary background-primary p-x1 shadow-l2'
      )}
      onKeyDown={handleKeyDown}
      ref={menuRef}
    >
      {children}
    </div>
  );
};

export default MenuStatic;
